import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  sectionWrapper: {
    padding: '0 .5rem',
    marginTop: 32
  },
  sectionTitle: {
    color: '#465869',
    fontSize: 16,
    fontWeight: 700,
    fontFamily: "'Manrope', sans-serif ",
    lineHeight: "24px",
    marginBottom: 24
  },
  buttonInactiveIcon: {
    fontSize: 14,
    marginRight: 13.5
  },
  buttonInactive: {
    width: 172
  }
}))

export default styles